import { useMutation } from 'react-query';
import { mailerService } from '../../../services';
import { SendSignUpMailerProps } from '../../../types';
import { enqueueSnackbar } from '../../../design-system';
import { MESSAGES } from '../../../const';

export const useSendContractMailerMutation = () => {
  return useMutation(mailerService.sendContract);
};

export const useSendSignUpMailerMutation = () => {
  return useMutation(
    ({
      city,
      companyLegalName,
      contactPersonFirstName,
      contactPersonLastName,
      country,
      companyEmail,
      companyPhoneNumber,
      streetAddress,
      messengers = [],
      containerNumber,
      price,
      category,
    }: SendSignUpMailerProps) => {
      const props: any = {
        link: window.location.pathname,
        legalName: companyLegalName,
        address: {
          streetAddress,
          city,
          country,
        },
        email: companyEmail,
        phoneNumber: companyPhoneNumber,
        contactPerson: {
          firstName: contactPersonFirstName,
          lastName: contactPersonLastName,
        },
        messengers: messengers.filter((item) => !!item.label && !!item.identifier),
      };

      if (category) {
        props.category = category;
      }

      if (!!price || !!containerNumber) {
        props.price = price;
        props.containerNumber = containerNumber;
      }

      return mailerService.sendSignUp(props);
    },
    {
      onError: (err: any) => {
        if (err.response.data.statusCode === 429) {
          enqueueSnackbar(MESSAGES.NETWORK.TOO_MANY_REQUESTS, 'error');
        }
      },
    },
  );
};
